/**
 * Turn aligned A/B buckets into recharts rows for one metric. Each row carries both the
 * A and B values plus each side's real bucket label (so the tooltip shows both dates).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { AlignedRow } from '../../data/types';
import type { CompareMetric } from '../../metrics/compareMetrics';
import { readBucketMetric } from '../../metrics/metricFormat';

export interface ChartRow {
  /** X-axis label (A's bucket label, falling back to B's). */
  label: string;
  a: number | null;
  b: number | null;
  labelA?: string;
  labelB?: string;
}

export function buildChartRows(aligned: AlignedRow[], metric: CompareMetric): ChartRow[] {
  return aligned.map((row) => ({
    label: row.bucketA?.bucketLabel ?? row.bucketB?.bucketLabel ?? '',
    a: readBucketMetric(row.bucketA, metric),
    b: readBucketMetric(row.bucketB, metric),
    labelA: row.bucketA?.bucketLabel,
    labelB: row.bucketB?.bucketLabel,
  }));
}
